import { z } from 'zod';
import { overlayKindSchema } from './kinds.js';
import { overlayTokenSlotSchema } from './overlay-token-slot.schema.js';
/**
 * 한 슬롯의 공개 주소다. `token`은 불투명 비밀이고, 폐기 시각이 있으면 그 슬롯은 비어 있다.
 */
export const overlayTokenSchema = z.object({
    /**
     * 이 비밀이 여는 오버레이 종류다. 슬롯이 달라도 kind는 같다.
     */
    kind: overlayKindSchema,
    /**
     * 불투명 비밀이다. URL 쿼리 `token`과 같다. JWT가 아니다.
     */
    token: z.string(),
    /**
     * 폐기 시각이다. 있으면 그 슬롯은 비어 있고, 민트 시 같은 행을 덮어쓴다.
     */
    revokedAt: z.union([z.string(), z.null()]),
    /**
     * 주소1 또는 주소2다. 값은 `OVERLAY_TOKEN_SLOTS`에서 온다.
     */
    slot: overlayTokenSlotSchema,
});
/**
 * issue·regenerate·revoke 한 번의 결과다.
 * `addresses`는 같은 kind의 슬롯 목록이라, 클라이언트가 주소1과 주소2를 구분한다.
 */
export const overlayTokenCommandSchema = overlayTokenSchema.extend({
    /**
     * 같은 kind의 슬롯별 주소다. 라이브와 폐기된 행을 모두 담는다.
     */
    addresses: z.array(overlayTokenSchema),
});
/**
 * 발급 요청의 필드다. `null` 본문과 구분하려고 객체만 둔다.
 */
export const overlayTokenIssueFieldsSchema = z
    .object({
    /**
     * 지정한 슬롯을 가져오거나, 없거나 폐기됐으면 그 슬롯에 민트한다.
     */
    slot: overlayTokenSlotSchema.optional(),
    /**
     * 비어 있는 첫 슬롯에 민트한다. 라이브 로테이션의 민트 경로다.
     */
    mintEmpty: z.boolean().optional(),
})
    .strict();
/**
 * `POST .../token` 본문이다. `null`이나 생략은 라이브 비밀을 가져오거나, 없으면 민트한다.
 */
export const overlayTokenIssueBodySchema = overlayTokenIssueFieldsSchema.nullable().optional();
/**
 * 덮어쓸 슬롯이다. 생략하면 주소1을 덮어쓴다. 라이브 중 하드 컷이다.
 */
export const overlayTokenRegenerateBodySchema = z
    .object({
    /**
     * 덮어쓸 슬롯이다. 없으면 주소1이다.
     */
    slot: overlayTokenSlotSchema.optional(),
})
    .strict()
    .nullable()
    .optional();
/**
 * 폐기할 슬롯이다. 슬롯을 빼면 어떤 주소를 끊는지 모호해지므로 필수다.
 */
export const overlayTokenRevokeBodySchema = z
    .object({
    /**
     * 폐기할 슬롯이다. 다른 슬롯의 라이브 비밀은 유지한다.
     */
    slot: overlayTokenSlotSchema,
})
    .strict();
//# sourceMappingURL=overlay-token.schema.js.map